// Async boundary required by Module Federation for shared dependency negotiation
import("./bootstrap");
